<template>
    <button class="share-icon"><slot /></button>
</template>

<script setup>

</script>

<style scoped>
    .share-icon {
        background-color: #ffffff;
        /*border: 1px solid #dcdfe6;*/
        border: 0;
        font-size: 28px;
        width: 32px;
        height: 32px;
        /* border-radius: 3px; */
        /*color: #FFFFFF;*/
        top: 1px;
        position: relative;
        cursor: pointer;
        padding: 0;
        text-align: center;
        line-height: 32px;
    }
</style>